module.exports = __webpack_public_path__ + "img/pencil.44f0d663.svg";